/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddActivityRequestAttachments
 */
export interface AddActivityRequestAttachments {
    /**
     * 
     * @type {string}
     * @memberof AddActivityRequestAttachments
     */
    base64: string;
    /**
     * 
     * @type {string}
     * @memberof AddActivityRequestAttachments
     */
    name: string;
}

export function AddActivityRequestAttachmentsFromJSON(json: any): AddActivityRequestAttachments {
    return AddActivityRequestAttachmentsFromJSONTyped(json, false);
}

export function AddActivityRequestAttachmentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddActivityRequestAttachments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base64': json['base64'],
        'name': json['name'],
    };
}

export function AddActivityRequestAttachmentsToJSON(value?: AddActivityRequestAttachments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'base64': value.base64,
        'name': value.name,
    };
}


